import LegalLayout from "@/components/LegalLayout";
import { BUSINESS } from "@/lib/business";

export default function Cookies() {
    return (
        <LegalLayout
            testId="cookies-page"
            title="Política de Cookies"
            intro={`Esta Política de Cookies explica qué son las cookies, qué tipos de cookies utiliza el sitio web de ${BUSINESS.name} y cómo puedes gestionarlas.`}
        >
            <h2>1. ¿Qué son las cookies?</h2>
            <p>
                Las cookies son pequeños ficheros de texto que los sitios web que visitas almacenan en tu dispositivo. Se utilizan ampliamente para hacer que los sitios web funcionen, o funcionen de manera más eficiente, así como para proporcionar información a los propietarios del sitio.
            </p>

            <h2>2. ¿Qué cookies utilizamos?</h2>
            <p>
                Este sitio web utiliza únicamente <strong>cookies técnicas propias</strong>, necesarias para su correcto funcionamiento. <strong>No usamos cookies analíticas, publicitarias ni de seguimiento de terceros.</strong>
            </p>

            <h3>Cookies técnicas (propias)</h3>
            <ul>
                <li>
                    <strong>frodrigo_cookie_consent_v1</strong> — Almacena tu preferencia respecto al aviso de cookies para no volver a mostrártelo. Se conserva en tu navegador y puedes borrarla en cualquier momento. Duración: permanente hasta que la elimines.
                </li>
            </ul>

            <h2>3. Cookies de terceros</h2>
            <p>
                En la sección de contacto se incluye un mapa integrado de <strong>Google Maps</strong> que puede instalar cookies de terceros de Google para el correcto funcionamiento del mapa. Puedes consultar la política de cookies de Google en:{" "}
                <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">
                    policies.google.com/technologies/cookies
                </a>.
            </p>

            <h2>4. Cómo gestionar o eliminar las cookies</h2>
            <p>
                Puedes configurar tu navegador para aceptar o rechazar las cookies, así como para eliminar las ya existentes. A continuación te facilitamos enlaces a las instrucciones de los principales navegadores:
            </p>
            <ul>
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
                <li><a href="https://support.microsoft.com/es-es/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
            </ul>

            <h2>5. Consentimiento</h2>
            <p>
                Al acceder al sitio web te mostramos un aviso con información sobre el uso de cookies. Puedes aceptarlas o rechazarlas; en caso de rechazarlas, únicamente se mantendrán las cookies técnicas estrictamente necesarias para el funcionamiento del sitio.
            </p>

            <h2>6. Modificaciones</h2>
            <p>
                {BUSINESS.name} podrá modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos.
            </p>

            <h2>7. Contacto</h2>
            <p>
                Si tienes dudas sobre esta Política de Cookies, puedes contactar con nosotros en{" "}
                <a href={BUSINESS.emailHref}>{BUSINESS.email}</a> o en el teléfono {BUSINESS.phone}.
            </p>

            <p className="mt-10 text-sm text-brand-ink/60">Última actualización: {new Date().toLocaleDateString("es-ES", { year: "numeric", month: "long" })}.</p>
        </LegalLayout>
    );
}
